import { render, staticRenderFns } from "./DictionaryView.vue?vue&type=template&id=cdb6e750"
import script from "./DictionaryView.vue?vue&type=script&lang=js"
export * from "./DictionaryView.vue?vue&type=script&lang=js"
import style0 from "./DictionaryView.vue?vue&type=style&index=0&id=cdb6e750&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports